(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.amse = {
    attach: function (context, settings) {
      // Sélection du bouton hamburger
      var $toggle = $('button.navbar-toggler', context);

      // On retire l'ancien handler pour éviter les bind multiples
      $toggle.off('click.amseMenu')
        .on('click.amseMenu', function () {
          // 1) Ouverture de la fenêtre Superfish mobile comme avant
          if (!$('#superfish-main-accordion').hasClass('sf-expanded')) {
            $('#superfish-main-toggle').click();
          }
          if (!$('#superfish-top-menu-accordion').hasClass('sf-expanded')) {
            $('#superfish-top-menu-toggle').click();
          }

          // 2) Après un court délai pour laisser le DOM afficher le wrapper
          setTimeout(function () {
            var $wrapper = $('#superfish-main-accordion');

            // 2.a) Forcer l'affichage du <ul> parent
            $wrapper
              .children('ul')
              .removeClass('sf-hidden')
              .css('display', 'block');

            // 2.b) Déplier les LI menuparent contenant un lien .is-active
            $wrapper.find('li.menuparent').has('a.is-active').each(function () {
              $(this)
                .children('a.sf-accordion-button')
                .trigger('click');
            });
          }, 150);
        });
    }
  };
})(jQuery, Drupal);
